import React from 'react';
import { Users, Store, UserX } from 'lucide-react';

interface DistributorStatCardsProps {
  totalDistributors?: number;
  activeDistributors?: number;
  inactiveDistributors?: number;
  totalRoutes?: number;
}

export const DistributorStatCards: React.FC<DistributorStatCardsProps> = ({
  totalDistributors = 128,
  activeDistributors = 112,
  inactiveDistributors = 16,
  totalRoutes: _totalRoutes = 56,
}) => {
  const activePercentage = ((activeDistributors / totalDistributors) * 100).toFixed(1);
  const inactivePercentage = ((inactiveDistributors / totalDistributors) * 100).toFixed(1);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-6 select-none">
      {/* Total Distributors */}
      <div className="bg-white rounded-2xl p-5 border border-[#ECECF2] shadow-sm flex items-center gap-4 hover:shadow-md transition-shadow">
        <div className="w-12 h-12 rounded-2xl bg-rose-100/70 text-rose-600 flex items-center justify-center shrink-0">
          <Users className="w-6 h-6" />
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-semibold text-slate-500">Total Distributors</span>
          <span className="text-2xl font-extrabold text-slate-800 tracking-tight mt-0.5">
            {totalDistributors}
          </span>
          <span className="text-[11px] font-bold text-emerald-600 mt-1">
            +5 this month
          </span>
        </div>
      </div>

      {/* Active Distributors */}
      <div className="bg-white rounded-2xl p-5 border border-[#ECECF2] shadow-sm flex items-center gap-4 hover:shadow-md transition-shadow">
        <div className="w-12 h-12 rounded-2xl bg-blue-100/70 text-blue-600 flex items-center justify-center shrink-0">
          <Store className="w-6 h-6" />
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-semibold text-slate-500">Active Distributors</span>
          <span className="text-2xl font-extrabold text-slate-800 tracking-tight mt-0.5">
            {activeDistributors}
          </span>
          <span className="text-[11px] font-bold text-emerald-600 mt-1">
            {activePercentage}% of total
          </span>
        </div>
      </div>

      {/* Inactive Distributors */}
      <div className="bg-white rounded-2xl p-5 border border-[#ECECF2] shadow-sm flex items-center gap-4 hover:shadow-md transition-shadow">
        <div className="w-12 h-12 rounded-2xl bg-orange-100/70 text-orange-600 flex items-center justify-center shrink-0">
          <UserX className="w-6 h-6" />
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-semibold text-slate-500">Inactive Distributors</span>
          <span className="text-2xl font-extrabold text-slate-800 tracking-tight mt-0.5">
            {inactiveDistributors}
          </span>
          <span className="text-[11px] font-bold text-rose-500 mt-1">
            {inactivePercentage}% of total
          </span>
        </div>
      </div>
    </div>
  );
};
